var e = {
	tabs: {
		home: "Home",
		bookings: "Bookings",
		messages: "Messages",
		account: "Account",
		search: "Search"
	},
	bookings: {
		title: "Bookings",
		empty: "Upcoming stays and pending booking requests will appear here.",
		list: {
			tabs: {
				active: "Active",
				past: "Past"
			},
			empty: {
				active: "Upcoming stays and pending requests will appear here.",
				past: "Your completed bookings will show up here."
			}
		},
		card: {
			guest: "Guest",
			amount: "Booking total",
			nights_one: "{{count}} night",
			nights_other: "{{count}} nights",
			guests_one: "{{count}} guest",
			guests_other: "{{count}} guests",
			seats_one: "{{count}} seat",
			seats_other: "{{count}} seats",
			noImage: "No image",
			sessionRange: "{{start}} – {{end}}"
		},
		details: {
			title: "{{guest}}'s stay at {{listing}}",
			titleFallback: "Booking details",
			confirmation: "Confirmation {{id}}",
			guestDetails: "Guest details",
			notFound: {
				title: "Booking not found",
				body: "This booking doesn't exist or isn't in your workspace."
			}
		},
		guestPaid: { title: "What the guest paid" },
		earnings: {
			title: "Earnings breakdown",
			gross: "Gross income",
			commission: "Platform fee ({{percent}}%)",
			pspFee: "Processing fee",
			payout: "Your payout",
			includesInsurance: "Includes {{amount}} non-refundable cancellation insurance."
		}
	},
	messages: {
		title: "Messages",
		empty: "Conversations with your guests will appear here."
	},
	search: {
		title: "Search",
		empty: "Search your bookings, listings, and chats."
	},
	account: {
		title: "Hosting",
		switchToGuest: "Switch to guest",
		switchError: "Couldn't switch profiles. Please try again.",
		logOut: "Log out"
	}
};
//#endregion
export { e as default };
